import React from "react";
import { MessageSquare, Instagram, Send, Database, Globe, Zap } from "lucide-react";

const Integrations = () => {
  const platforms = [
    { name: "WhatsApp", icon: <MessageSquare className="h-8 w-8" />, color: "text-green-500" },
    { name: "Instagram", icon: <Instagram className="h-8 w-8" />, color: "text-pink-500" },
    { name: "Telegram", icon: <Send className="h-8 w-8" />, color: "text-blue-500" },
    { name: "CRM", icon: <Database className="h-8 w-8" />, color: "text-purple-500" },
    { name: "Web", icon: <Globe className="h-8 w-8" />, color: "text-indigo-500" },
    { name: "APIs", icon: <Zap className="h-8 w-8" />, color: "text-yellow-500" }
  ];

  return (
    <section id="integraciones" className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-800 mb-6">
            Conectamos con tu{" "}
            <span className="text-orange-500">ecosistema digital</span>
          </h2>
          
          <p className="text-lg lg:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-8">
            Nuestros sistemas se adaptan perfectamente a tu infraestructura actual, conectando 
            con tus herramientas de gestión, canales de comunicación y plataformas de redes sociales.
          </p>
          
          <p className="text-base lg:text-lg text-gray-500 max-w-3xl mx-auto">
            Implementamos asistentes inteligentes en tu entorno digital para crear 
            una experiencia fluida y coherente en todos tus puntos de contacto.
          </p>
        </div>

        {/* Integration Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {platforms.map((platform, index) => (
            <div 
              key={index} 
              className="group relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105 text-center"
            >
              {/* Background gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-purple-50/50 to-blue-50/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
              
              <div className="relative z-10">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-xl bg-gray-50 group-hover:bg-white ${platform.color} mb-4 transition-colors shadow-sm`}>
                  {platform.icon}
                </div>
                <h3 className="font-semibold text-gray-800 group-hover:text-purple-600 transition-colors">
                  {platform.name}
                </h3>
              </div>
              
              {/* Connection lines */}
              <div className="absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-purple-300 to-transparent opacity-0 group-hover:opacity-100 transition-opacity hidden lg:block"></div>
            </div>
          ))}
        </div>

        {/* Central AI Hub */}
        <div className="mt-16 flex justify-center">
          <div className="relative">
            <div className="w-32 h-32 bg-gradient-to-br from-purple-600 to-blue-600 rounded-3xl flex items-center justify-center shadow-2xl shadow-purple-500/25 animate-pulse">
              <div className="text-white text-2xl font-bold">IA</div>
              
              {/* Connecting lines radiating out */}
              <div className="absolute inset-0">
                {[...Array(6)].map((_, i) => (
                  <div 
                    key={i}
                    className={`absolute w-20 h-0.5 bg-gradient-to-r from-purple-400 to-transparent transform origin-center animate-pulse`}
                    style={{
                      transform: `rotate(${i * 60}deg) translate(50px, 0)`,
                      top: '50%',
                      left: '50%',
                      marginLeft: '-10px',
                      marginTop: '-1px',
                      animationDelay: `${i * 0.2}s`
                    }}
                  ></div>
                ))}
              </div>
            </div>
            
            {/* Outer glow */}
            <div className="absolute inset-0 w-32 h-32 bg-gradient-to-br from-purple-400 to-blue-400 rounded-3xl blur-xl opacity-30 animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Integrations;